import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {
  BAR_CHART_CONFIG_SECTIONS,
  BAR_CHART_STYLE_SECTIONS,
} from '../step-config-settings/chart-schemas/BarChartSchema';
import {
  BOX_PLOT_CONFIG_SECTIONS,
  BOX_PLOT_STYLE_SECTIONS,
} from '../step-config-settings/chart-schemas/BoxPlotSchema';
import {createChartTypeSchema} from '../step-config-settings/chart-schemas/ChartSchemaHelpers';
import {
  HEATMAP_CONFIG_SECTIONS,
  HEATMAP_STYLE_SECTIONS,
} from '../step-config-settings/chart-schemas/HeatmapSchema';
import {
  LINE_CHART_CONFIG_SECTIONS,
  LINE_CHART_STYLE_SECTIONS,
} from '../step-config-settings/chart-schemas/LineChartSchema';
import {
  PIE_CHART_CONFIG_SECTIONS,
  PIE_CHART_STYLE_SECTIONS,
} from '../step-config-settings/chart-schemas/PieChartSchema';
import {
  SCATTER_CHART_CONFIG_SECTIONS,
  SCATTER_CHART_STYLE_SECTIONS,
} from '../step-config-settings/chart-schemas/ScatterChartSchema';
import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {FIELD_ORDER_UI_SCHEMA_KEY, TAB_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const CHART_VIEW_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.CHART_VIEW, 0> = {
  [TAB_ORDER_UI_SCHEMA_KEY]: ['configure', 'style'],

  configure: {
    displayName: 'Configure',
    uiSchema: {
      [FIELD_ORDER_UI_SCHEMA_KEY]: [
        'boxPlotConfigure',
        'pieChartConfigure',
        'lineChartConfigure',
        'heatMapConfigure',
        'scatterChartConfigure',
        'barChartConfigure',
      ],
      boxPlotConfigure: createChartTypeSchema('BOX_PLOT', BOX_PLOT_CONFIG_SECTIONS),
      pieChartConfigure: createChartTypeSchema('PIE_CHART', PIE_CHART_CONFIG_SECTIONS),
      lineChartConfigure: createChartTypeSchema('LINE_CHART', LINE_CHART_CONFIG_SECTIONS),
      heatMapConfigure: createChartTypeSchema('HEATMAP', HEATMAP_CONFIG_SECTIONS),
      scatterChartConfigure: createChartTypeSchema('SCATTER_PLOT', SCATTER_CHART_CONFIG_SECTIONS),
      barChartConfigure: createChartTypeSchema('BAR_CHART', BAR_CHART_CONFIG_SECTIONS),
    },
  },
  style: {
    displayName: 'Style',
    uiSchema: {
      [FIELD_ORDER_UI_SCHEMA_KEY]: [
        'boxPlotStyle',
        'pieChartStyle',
        'lineChartStyle',
        'heatmapStyle',
        'scatterChartStyle',
        'barChartStyle',
      ],
      boxPlotStyle: createChartTypeSchema('BOX_PLOT', BOX_PLOT_STYLE_SECTIONS),
      pieChartStyle: createChartTypeSchema('PIE_CHART', PIE_CHART_STYLE_SECTIONS),
      lineChartStyle: createChartTypeSchema('LINE_CHART', LINE_CHART_STYLE_SECTIONS),
      heatmapStyle: createChartTypeSchema('HEATMAP', HEATMAP_STYLE_SECTIONS),
      scatterChartStyle: createChartTypeSchema('SCATTER_PLOT', SCATTER_CHART_STYLE_SECTIONS),
      barChartStyle: createChartTypeSchema('BAR_CHART', BAR_CHART_STYLE_SECTIONS),
    },
  },
};
